import React, { Fragment, useState, useEffect } from 'react';
import { instanceOf, func, bool } from 'prop-types';
import { useDispatch } from 'react-redux';
import { setIsEditTargetDefinition, setOrginalTargetName } from '../../../actions/deActions/deImportDefActions';
import definitionSaveButton from '../../../images/Autocode/definitionSaveButton.svg';
import definitionCancelButton from '../../../images/Autocode/definitionCancelButton.svg';

const DEEditableField = ({ row, validateLabel, hasError }) => {
  const dispatch = useDispatch();
  const [isEditable, setIsEditable] = useState(false);
  const [value, setValue] = useState(row.tn);
  useEffect(() => {
    setValue(row.tn);
  }, [row]);

  useEffect(() => {
    if (isEditable) {
      const selectedInput = document.getElementById(row.ui);
      if(selectedInput !== null){
        selectedInput.select();
        selectedInput.focus();
      }
      dispatch(setIsEditTargetDefinition(true));
    }
  }, [isEditable]);

  const handleChange = updatedLabel => {
    setValue(updatedLabel);
  };

  const _validateLabel = async updatedLabel => {
    if (updatedLabel.trim()) {
      const rowData = {
        ...row,
        tn: updatedLabel,
      };
      const res = await validateLabel(rowData, hasError);
      if (!res) {
        return false
      }
    } else {
      setValue(row.tn);
      dispatch(setIsEditTargetDefinition(false));
    }
    setIsEditable(false);
    return true
  };

  const cancelEditTarget = (row) => {
    dispatch(setOrginalTargetName(row));
    setIsEditable(false);
  }
  return (
    <Fragment>
      {isEditable ? (
        <span>
          <input
            id={row.ui}
            type="text"
            value={value}
            onChange={e => handleChange(e.target.value)}
            className="de--import-def__editable-input"
            onBlur={() => _validateLabel(value)}
            autoComplete="off"
          />
          <span className="pull-right ac-rp-edit-btns">
            <img
              className="ac-rp-save-btn"
              src={definitionSaveButton}
              alt="save"
              title="Save"
              onMouseDown={() => {
                _validateLabel(value)
              }}
            />
            <img
              className="ac-rp-cancel-btn"
              src={definitionCancelButton}
              alt="cancel"
              title="Cancel"
              onMouseDown={() => {
                cancelEditTarget(row);
              }}
            />
          </span>
        </span>
      ) : (
        <button
          id={row.ui}
          className={`de--import-def__row-btn de--import-def__row--name
         ${hasError ? 'de--import-def__row--error' : ''}`}
          type="button"
          title={row.tn}
          onDoubleClick={() => setIsEditable(true)}
        >
          {value}
        </button>
      )}
    </Fragment>
  );
};

DEEditableField.propTypes = {
  row: instanceOf(Object),
  validateLabel: func,
  hasError: bool,
};

export default DEEditableField;
